/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaGNVertPublicConfiguration {
  rootUrl: string = '/web';
}

/**
 * Parameters for `ShivaGNVertPublicModule.forRoot()`
 */
export interface ShivaGNVertPublicConfigurationParams {
  rootUrl?: string;
}
